module.exports = __webpack_public_path__ + "img/timer.bb7de20d.svg";